import cx from "classnames";
import React, { HTMLAttributes, forwardRef } from "react";

type DashboardContainerProps = {
  children: React.ReactNode;
  className?: string;
  hasMaximumWidth?: boolean;
};

const Header = ({
  children,
  className,
  sticky,
}: DashboardContainerProps & { sticky?: boolean }) => (
  <div
    className={cx("t-flex-[0_0_auto]", className || "", {
      "t-sticky t-top-0 t-bg-surface t-z-header": sticky,
    })}
  >
    {children}
  </div>
);

const Content = ({
  children,
  className = "",
  hasMaximumWidth = false,
  ...props
}: DashboardContainerProps & HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cx(
      "t-flex-auto t-overflow-y-auto",
      {
        "t-w-full lg:!t-w-[1135px]": hasMaximumWidth,
      },
      className
    )}
    {...props}
  >
    {children}
  </div>
);

const DashboardContainer = Object.assign(
  forwardRef<HTMLDivElement, DashboardContainerProps>(
    ({ children, className }, ref) => {
      return (
        <div
          ref={ref}
          className={cx("t-flex t-flex-col t-w-full", className || "")}
        >
          {children}
        </div>
      );
    }
  ),
  {
    Header,
    Content,
  }
);

export default DashboardContainer;
